import { css } from "@emotion/react";

export const termsCheckbox = css`
  text-align: left;
`;
